import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom"; // Updated imports for routing
import { Offcanvas, Collapse, Button, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import styles from "page.module.css"; // Update path as per your project structure

const MobileSideBar = ({ showSubSidebar, setShowSubSidebar }) => {
  const [openTopic, setOpenTopic] = useState(null);
  const [openSubTopic, setOpenSubTopic] = useState(null);
  const [openBilling, setOpenBilling] = useState(false);
  const [openHistory, setOpenHistory] = useState(false);
  const location = useLocation(); // Use `useLocation` from react-router-dom to get current path
  const pathname = location.pathname;
  const isLandingPage = pathname === "/";

  const handleToggle = (topic) => {
    setOpenTopic(openTopic === topic ? null : topic);
    setOpenSubTopic(null); // Close subtopics when changing main topics
    // Close billing and history sections when opening main menu items
    if (openTopic !== topic) {
      setOpenBilling(false);
      setOpenHistory(false);
    }
  };

  const handleSubToggle = (subTopic) => {
    setOpenSubTopic(openSubTopic === subTopic ? null : subTopic);
  };

  const handleBillingToggle = () => {
    setOpenBilling(!openBilling);
    // Close other sections when opening billing
    if (!openBilling) {
      setOpenTopic(null);
      setOpenSubTopic(null);
      setOpenHistory(false);
    }
  };

  const handleHistoryToggle = () => {
    setOpenHistory(!openHistory);
    // Close other sections when opening history
    if (!openHistory) {
      setOpenTopic(null);
      setOpenSubTopic(null);
      setOpenBilling(false);
    }
  };

  const menu = {
    content_editor: {
      name: "CONTENT EDITOR",
      submenu: [
        {
          name: "Content Journey",
          submenu: [
            {
              name: "Keyword",
              link: "/content_editor/content_journey/keyword",
            },
            {
              name: "URL",
              link: "/content_editor/content_journey/url",
            },
          ],
        },
        {
          name: "Headline Generation",
          submenu: [
            {
              name: "Headline Creation",
              link: "/content_editor/headlines/keyword",
            },
            {
              name: "URL",
              link: "/content_editor/headlines/url",
            },
          ],
        },
        {
          name: "Writer",
          submenu: [
            {
              name: "URL",
              link: "/content_editor/writer/url",
            },
            {
              name: "Keyword",
              link: "/content_editor/writer/keyword",
            },
            {
              name: "Content",
              link: "/content_editor/writer/content",
            },
          ],
        },
        {
          name: "Keyword Discovery",
          submenu: [
            {
              name: "Keyword",
              link: "/content_editor/keyword_discovery/keyword",
            },
            {
              name: "URL",
              link: "/content_editor/keyword_discovery/url",
            },
          ],
        },
        {
          name: "AI Overview",
          submenu: [
            {
              name: "Keyword",
              link: "/content_editor/ai_overview/keyword",
            },
            {
              name: "URL",
              link: "/content_editor/ai_overview/url",
            },
            {
              name: "Content",
              link: "/content_editor/ai_overview/content",
            },
          ],
        },
        {
          name: "Import Content",
          submenu: [
            {
              name: "Content",
              link: "/content_editor/import_content/content",
            },
          ],
        }
      ],
    },    
    seo: {
      name: "SEO",
      submenu: [
        {
          name: "Keyword Research",
          submenu: [
            { name: "Keyword", link: "/seo/keyword_research/keyword" },
            { name: "URL", link: "/seo/keyword_research/url" },
          ],
        },
        {
          name: "SEO Title",
          submenu: [
            { name: "Single Keyword", link: "/seo/title/keyword"},
            { name: "URL", link: "/seo/title/url", disabled: true },
          ],
        },
        {
          name: "SEO Meta Description",
          submenu: [
            {
              name: "Single Keyword",
              link: "/seo/meta_description/keyword",
            },
            { name: "URL", link: "/seo/meta_description/url", disabled: true },
          ],
        },
        {
          name: "Ranking",
          submenu: [
            { name: "Keyword", link: "/seo/ranking/keyword" },
            { name: "Domain Ranking", link: "/seo/ranking/domain_ranking", disabled: true },
            { name: "Page Ranking", link: "/seo/ranking/page_ranking", disabled: true },
          ],
        },
        {
          name: "Image ALT Tags",
          submenu: [
            {
              name: " Keyword-Based Optimisation",
              link: "/seo/image/keyword_optimisation",
            },
            {
              name: " ALT Tag Optimisation",
              link: "/seo/image/alt_tag_optimisation",
              disabled: true,
            },
          ],
        }
      ],
    },
    social: {
      name: "SOCIAL",
      submenu: [
        { name: "META + INSTA", link: "/social/meta_insta/tags" },
        { name: "Content Creation", link: "/social/meta_insta/content_creation" },
      ],
    }
  };

  const billingItems = [
    { name: "Plans", link: "/plans" },
    { name: "Transactions", link: "/plans/transactions" },
    { name: "Actions", link: "/billing/activity" },
  ];

  const historyItems = [
    { name: "Activity", link: "/billing/activity" }
  ];

  // if (
  //   derivedState &&
  //   derivedState.authenticateResponse?.roles === "buddyx_admin"
  // ) {
  //   menu["ranking"] = {
  //     name: "Ranking",
  //     submenu: [
  //       {
  //         name: "Single Keyword Ranking",
  //         link: "/ranking/single_keyword_ranking",
  //       },
  //       {
  //         name: "Multiple Keyword Ranking",
  //         link: "/ranking/multiple_keywords_ranking",
  //       },
  //       { name: "Domain Ranking", link: "/ranking/domain_ranking" },
  //       { name: "Page Ranking", link: "/ranking/page_ranking" },
  //       { name: "SERPs", link: "/ranking/SERPs" },
  //     ],
  //   };
  // }

  return (
    <Offcanvas
      show={showSubSidebar}
      onHide={() => setShowSubSidebar(false)}
      placement="end"
      className={`my-5 ${styles.offcanvas_custom}`}
      style={{ height: "100%" }}
      backdrop={true}
      scroll={false}
    >
      <Offcanvas.Header>
        <Offcanvas.Title id="offcanvasRightLabel">Menu</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        {isLandingPage ? (
          // Show only Sign In and Plans for landing page
          <div className="d-flex flex-column gap-3">
            <Link
              to="/signIn"
              className="btn btn-primary w-100 py-3 text-decoration-none"
              style={{ fontSize: "1.1rem" }}
              onClick={() => setShowSubSidebar(false)}
            >
              Sign In
            </Link>
            <Link
              to="/plans"
              className="btn btn-outline-primary w-100 py-3 text-decoration-none"
              style={{ fontSize: "1.1rem" }}
              onClick={() => setShowSubSidebar(false)}
            >
              Plans
            </Link>
          </div>
        ) : (
          // Show full menu for other pages
          <>
            {Object.keys(menu).map((key) => {
              const topic = menu[key];
              const isOpen = openTopic === key;

              return (
                <div key={key} className="mb-2">
                  <Button
                    className="w-100 mb-2 d-flex align-items-center justify-content-start menu-item"
                    variant="light"
                    onClick={() => handleToggle(key)}
                    aria-controls={`collapse-${key}`}
                    aria-expanded={isOpen}
                    style={{ textAlign: "left" }}
                  >
                    <div className="d-flex align-items-center">
                      <FontAwesomeIcon
                        icon={isOpen ? faChevronDown : faChevronRight}
                        className="me-2"
                      />
                      <span>{topic.name}</span>
                    </div>
                  </Button>
                  <Collapse in={isOpen}>
                    <div id={`collapse-${key}`}>
                      <Card style={{ border: "none" }}>
                        <Card.Body>
                          <ul className="list-unstyled">
                            {topic.submenu.map(({ name, link, submenu, disabled }, index) => (
                              <div key={index} className="mb-3">
                                {submenu ? (
                                  <>
                                    <Button
                                      className="w-100 text-start"
                                      variant="light"
                                      onClick={() =>
                                        submenu && handleSubToggle(name)
                                      }
                                      aria-controls={`collapse-${key}-${name}`}
                                      aria-expanded={openSubTopic === name}
                                      style={{ textAlign: "left" }}
                                    >
                                      <div className="d-flex align-items-center">
                                        {submenu && (
                                          <FontAwesomeIcon
                                            icon={
                                              openSubTopic === name
                                                ? faChevronDown
                                                : faChevronRight
                                            }
                                            className="me-2"
                                          />
                                        )}
                                        <span>{name}</span>
                                      </div>
                                    </Button>
                                    <Collapse in={openSubTopic === name}>
                                      <div
                                        id={`collapse-${key}-${name}`}
                                        className="ms-3 collapse"
                                      >
                                        <ul className="list-unstyled">
                                          {submenu?.map(
                                            ({ name: subName, link, disabled }, subIndex) => (
                                              <div
                                                key={subIndex}
                                                className="mb-2 collapse-item"
                                              >
                                                {disabled ? (
                                                  <div
                                                    className={`${styles.subtopicItem} text-wrap w-100 d-flex align-items-center`}
                                                    style={{
                                                      textDecoration: "none",
                                                      color: "#6c757d",
                                                      fontWeight: "normal",
                                                      cursor: "not-allowed",
                                                      opacity: 0.6,
                                                    }}
                                                  >
                                                    <span>{subName}</span>
                                                    <small className="ms-2 text-muted">(Coming Soon)</small>
                                                  </div>
                                                ) : (
                                                  <Link
                                                    to={link}
                                                    className={`${styles.subtopicItem} text-wrap w-100 d-flex align-items-center`}
                                                    style={{
                                                      textDecoration: "none",
                                                      color:
                                                        pathname === link
                                                          ? "blue"
                                                          : "black",
                                                      fontWeight:
                                                        pathname === link
                                                          ? "bold"
                                                          : "normal",
                                                    }}
                                                  >
                                                    <span>{subName}</span>
                                                  </Link>
                                                )}
                                              </div>
                                            )
                                          )}
                                        </ul>
                                      </div>
                                    </Collapse>
                                  </>
                                ) : (
                                  <>
                                    {disabled ? (
                                      <div
                                        className={`${styles.subtopicItem} text-wrap w-100 d-flex align-items-center`}
                                        style={{
                                          textDecoration: "none",
                                          color: "#6c757d",
                                          fontWeight: "normal",
                                          cursor: "not-allowed",
                                          opacity: 0.6,
                                        }}
                                      >
                                        <span>{name}</span>
                                        <small className="ms-2 text-muted">(Coming Soon)</small>
                                      </div>
                                    ) : (
                                      <Link
                                        to={link}
                                        className={`${styles.subtopicItem} text-wrap w-100 d-flex align-items-center`}
                                        style={{
                                          textDecoration: "none",
                                          color: pathname === link ? "blue" : "black",
                                          fontWeight:
                                            pathname === link ? "bold" : "normal",
                                        }}
                                      >
                                        <span>{name}</span>
                                      </Link>
                                    )}
                                    <hr
                                      style={{ borderTop: "2px solid #ccc" }}
                                      className="w-100"
                                    />
                                  </>
                                )}
                              </div>
                            ))}
                          </ul>
                        </Card.Body>
                      </Card>
                    </div>
                  </Collapse>
                </div>
              );
            })}
            
            <hr style={{ borderTop: "2px solid #ccc" }} className="w-100" />
            
            {/* Billing Section */}
            <div className="mb-2">
              <Button
                className="w-100 mb-2 d-flex align-items-center justify-content-start menu-item"
                variant="light"
                onClick={handleBillingToggle}
                aria-controls="collapse-billing"
                aria-expanded={openBilling}
                style={{ textAlign: "left" }}
              >
                <div className="d-flex align-items-center">
                  <FontAwesomeIcon
                    icon={openBilling ? faChevronDown : faChevronRight}
                    className="me-2"
                  />
                  <span>Billing</span>
                </div>
              </Button>
              <Collapse in={openBilling}>
                <div id="collapse-billing">
                  <Card style={{ border: "none" }}>
                    <Card.Body>
                      <ul className="list-unstyled">
                        {billingItems.map((item, idx) => (
                          <div key={idx} className="mb-2">
                            <Link
                              to={item.link}
                              className={`${styles.subtopicItem} text-wrap w-100 d-flex align-items-center`}
                              style={{
                                textDecoration: "none",
                                color: pathname === item.link ? "blue" : "black",
                                fontWeight: pathname === item.link ? "bold" : "normal",
                              }}
                              onClick={() => setShowSubSidebar(false)}
                            >
                              <span>{item.name}</span>
                            </Link>
                          </div>
                        ))}
                      </ul>
                    </Card.Body>
                  </Card>
                </div>
              </Collapse>
            </div>

            {/* History Section */}
            <div className="mb-2">
              <Button
                className="w-100 mb-2 d-flex align-items-center justify-content-start menu-item"
                variant="light"
                onClick={handleHistoryToggle}
                aria-controls="collapse-history"
                aria-expanded={openHistory}
                style={{ textAlign: "left" }}
              >
                <div className="d-flex align-items-center">
                  <FontAwesomeIcon
                    icon={openHistory ? faChevronDown : faChevronRight}
                    className="me-2"
                  />
                  <span>History</span>
                </div>
              </Button>
              <Collapse in={openHistory}>
                <div id="collapse-history">
                  <Card style={{ border: "none" }}>
                    <Card.Body>
                      <ul className="list-unstyled">
                        {historyItems.map((item, idx) => (
                          <div key={idx} className="mb-2">
                            <Link
                              to={item.link}
                              className={`${styles.subtopicItem} text-wrap w-100 d-flex align-items-center`}
                              style={{
                                textDecoration: "none",
                                color: pathname === item.link ? "blue" : "black",
                                fontWeight: pathname === item.link ? "bold" : "normal",
                              }}
                              onClick={() => setShowSubSidebar(false)}
                            >
                              <span>{item.name}</span>
                            </Link>
                          </div>
                        ))}
                      </ul>
                    </Card.Body>
                  </Card>
                </div>
              </Collapse>
            </div>
          </>
        )}
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default MobileSideBar;
